import { createRoot } from "react-dom/client";
import { App } from "./app.tsx";

const mount = document.getElementById("rally");
if (!mount) throw new Error("rally: the page has no mount point");

createRoot(mount).render(<App />);

if ("serviceWorker" in navigator) {
  addEventListener("load", () => {
    navigator.serviceWorker.register("/worker.js").catch(() => {});
  });
}
